import React from "react";
import Card from "./Card";
import Button from "./Button";

interface ConfirmModalProps {
    isOpen: boolean;
    title: string;
    description?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    variant?: "primary" | "secondary" | "danger";
    onConfirm: () => void | Promise<void>;
    onCancel: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
                                                       isOpen,
                                                       title,
                                                       description,
                                                       confirmLabel = "OK",
                                                       cancelLabel = "Отмена",
                                                       variant = "primary",
                                                       onConfirm,
                                                       onCancel,
                                                   }) => {
    if (!isOpen) return null;

    const confirmVariant =
        variant === "danger" ? "danger" : variant === "secondary" ? "secondary" : "primary";

    return (
        <div className="modal-backdrop">
            <div className="modal-dialog">
                <Card>
                    <div className="editor-head">
                        <div>
                            <h3 className="card-title">{title}</h3>
                            {description && <p className="card-text">{description}</p>}
                        </div>
                    </div>

                    <div className="editor-actions">
                        <Button type="button" variant="ghost" onClick={onCancel}>
                            {cancelLabel}
                        </Button>
                        <Button type="button" variant={confirmVariant} onClick={onConfirm}>
                            {confirmLabel}
                        </Button>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default ConfirmModal;
